import React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';

const Loader = () => (
  <div id="modal-loader">
    <PulseLoader color="#ddd" size="0.7rem" margin="0.2rem" />
  </div>
);

export default Loader;
